import Suggestions from './Suggestions'

export default Suggestions



// WEBPACK FOOTER //
// ./src/components/Form/components/AutoCompleteInput/components/Suggestions/index.js